import { render, staticRenderFns } from "./CaseDidi.vue?vue&type=template&id=fd230842&lang=pug"
import script from "./CaseDidi.vue?vue&type=script&lang=js"
export * from "./CaseDidi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports